'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = require('./');

exports.default = function (_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var apiAction = action[_.API_ACTION_TYPE];

      // Ignore non-api actions.
      if ((typeof apiAction === 'undefined' ? 'undefined' : _typeof(apiAction)) !== 'object') {
        return next(action);
      }

      var PENDING_TYPE = apiAction.types[0];
      var SUCCESS_TYPE = apiAction.types[1];
      var FAILURE_TYPE = apiAction.types[2];

      dispatch({
        type: PENDING_TYPE
      });

      return new Promise(function (resolve, reject) {
        fetch(apiAction.endpoint, apiAction.fetchOptions).then(function (response) {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        }).then(function (json) {
          dispatch({
            type: SUCCESS_TYPE,
            payload: json
          });

          resolve(json);
        }).catch(function (error) {
          dispatch({
            type: FAILURE_TYPE,
            payload: error
          });

          reject(error);
        });
      });
    };
  };
};
//# sourceMappingURL=middleware.js.map